export default __webpack_public_path__ + "static/media/a001-ransomware-01.25ee5572.png";